/**
 * Language choice (2026-10-23) — snippets/bombas-lang.liquid.
 * - First visit: the sheet (العربية / Français / English) opens ~1.5 s after `load`, once per visitor. A choice or a
 *   close is saved as a language (localStorage + cookie bb_lang, both in try/catch) and it never opens again by itself.
 * - The sheet (owner, 25 Oct 2026): 3 cards; a tap applies that language at once (same language: saves + closes, no
 *   reload). Closing (X, outside, Escape, drag) saves the current language as the choice.
 *   Centered card; on phones a bottom sheet (drag the handle down to close).
 * - Language selector "Français ▾" (owner, 25 Oct 2026): desktop top bar, phone header, phone menu
 *   (snippets/bombas-lang.liquid mode 'dropdown'). Its links and the footer links go through the same choice logic.
 * - Switching: same page in the other language = locale root (/ar, /en, / for French) + path without the current
 *   root + the current query and hash, so utm_*, fbclid, gclid and variant survive.
 * - Not shown while the store has a single published language (data-live="false"); preview only (never the live
 *   theme): ?bb_lang_test=1 shows it anyway, to test the UI.
 * - ?lang_popup=1 (owner, 24 Oct 2026): opens the sheet on every load, even after a choice / close, so it can be seen
 *   again and again. On a preview theme it also works before the languages are published; on the live theme only once
 *   they are (it never shows languages customers can't open).
 */
(function () {
  'use strict';

  var KEY = 'bb_lang';
  // The popup template isn't rendered on /cart: the selectors carry the same data.
  var tpl = document.getElementById('bb-lang-tpl');
  var cfg = tpl || document.querySelector('.bb-dd');
  if (!cfg) return;
  var live = cfg.dataset.live === 'true';
  var role = window.Shopify && Shopify.theme && Shopify.theme.role;
  var force = /[?&]lang_popup=1(?:&|$)/.test(location.search);
  var test = role && role !== 'main' && (force || /[?&]bb_lang_test=1\b/.test(location.search));
  if (!live && !test) return;
  var curRoot = cfg.dataset.root || '/';
  var sheet = null;
  var lastFocus = null;

  if (test) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bb-lang-pending]'), function (el) {
      el.hidden = false;
    });
  }

  function saved() {
    try {
      if (localStorage.getItem(KEY)) return true;
    } catch (e) {}
    try {
      return /(?:^|; )bb_lang=/.test(document.cookie);
    } catch (e) {
      return false;
    }
  }

  function save(value) {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {}
    try {
      document.cookie = KEY + '=' + value + '; max-age=31536000; path=/; SameSite=Lax';
    } catch (e) {}
  }

  // Same page in the language whose root is `root` (keeps query + hash).
  function urlFor(root) {
    var path = location.pathname;
    if (curRoot !== '/' && (path === curRoot || path.indexOf(curRoot + '/') === 0)) path = path.slice(curRoot.length) || '/';
    var target = root === '/' ? path : path === '/' ? root : root + path;
    return target + location.search + location.hash;
  }

  function onPick(e) {
    var a = e.target.closest && e.target.closest('a[data-bb-lang]');
    if (!a) return;
    e.preventDefault();
    apply(a.getAttribute('data-bb-lang'), a.getAttribute('data-bb-root') || '/', a.classList.contains('is-current'));
  }

  // Choice → cart attribute _lang (for Scalo's WhatsApp) right away; keepalive: it still goes out when the page changes
  // just after. scalo-meta-cookies also copies bb_lang on every page load.
  function cartLang(code) {
    if (!window.scaloMetaAttrs) return;
    try {
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _lang: code } }) }).catch(function () {});
    } catch (e) {}
  }

  // Saves the choice; the same language → closes (no page load), another → same page in that language.
  function apply(code, root, same) {
    save(code);
    cartLang(code);
    if (same) {
      close();
      closeDd();
      return;
    }
    window.location.assign(urlFor(root));
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  // Phone bottom sheet: drag the handle down to close.
  function dragClose(handle, card) {
    var y0 = null;
    var dy = 0;
    handle.addEventListener('pointerdown', function (e) {
      y0 = e.clientY;
      dy = 0;
      handle.setPointerCapture(e.pointerId);
      sheet && sheet.classList.add('is-dragging');
    });
    handle.addEventListener('pointermove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.clientY - y0);
      card.style.transform = 'translateY(' + dy + 'px)';
    });
    function end() {
      if (y0 === null) return;
      y0 = null;
      if (sheet) sheet.classList.remove('is-dragging');
      card.style.transform = '';
      if (dy > 80) close();
    }
    handle.addEventListener('pointerup', end);
    handle.addEventListener('pointercancel', end);
  }

  // Cairo is in the page only on Arabic pages: the panel shows Arabic on every page.
  function arFont() {
    var href = tpl.dataset.arfont;
    if (!href || document.documentElement.lang.indexOf('ar') === 0 || document.querySelector('link[data-bb-arfont]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.setAttribute('data-bb-arfont', '');
    document.head.appendChild(l);
  }

  // Dropdown selectors: one open at a time; outside click / Escape closes.
  function closeDd(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bb-dd][aria-expanded="true"]'), function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = b.parentNode.querySelector('.bb-dd__panel');
      if (p) p.hidden = true;
    });
  }

  function toggleDd(btn) {
    var opening = btn.getAttribute('aria-expanded') !== 'true';
    closeDd(btn);
    btn.setAttribute('aria-expanded', String(opening));
    var p = btn.parentNode.querySelector('.bb-dd__panel');
    if (p) p.hidden = !opening;
    if (opening && p) {
      var cur = p.querySelector('.bb-lang__opt.is-current') || p.querySelector('.bb-lang__opt');
      if (cur) cur.focus({ preventScroll: true });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var b = document.querySelector('[data-bb-dd][aria-expanded="true"]');
    if (!b) return;
    closeDd();
    b.focus({ preventScroll: true });
  });

  function open() {
    if (sheet || !tpl) return;
    lastFocus = document.activeElement;
    arFont();
    sheet = tpl.content.firstElementChild.cloneNode(true);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-bb-close]')) return close();
      // A card tap applies its language at once (owner, 25 Oct 2026: no "Continuer" button).
      var card = e.target.closest('.bb-lp__opt');
      if (card) {
        e.preventDefault();
        var code = card.getAttribute('data-bb-lang');
        apply(code, card.getAttribute('data-bb-root') || '/', code === tpl.dataset.cur);
      }
    });
    dragClose(sheet.querySelector('.bb-lp__grab'), sheet.querySelector('.bb-lp__card'));
    document.body.appendChild(sheet);
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!sheet) return;
        sheet.classList.add('is-open');
        // Focus in the dialog (not on a card: no focus ring before any key press); Tab reaches the cards.
        sheet.querySelector('.bb-lp__card').focus({ preventScroll: true });
      });
    });
  }

  function close() {
    if (!sheet) return;
    // X / outside / Escape / drag = keeping the current language (owner, 25 Oct 2026): saved like a choice, so the
    // panel never opens again by itself.
    if (!saved()) {
      var cur = (tpl && tpl.dataset.cur) || 'fr';
      save(cur);
      cartLang(cur);
    }
    var el = sheet;
    sheet = null;
    document.removeEventListener('keydown', onKey);
    el.classList.remove('is-open');
    setTimeout(function () {
      el.remove();
    }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // Selector button → its list; selector + footer links → same URL logic (adds the query); click elsewhere closes.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var dd = e.target.closest('[data-bb-dd]');
    if (dd) {
      e.preventDefault();
      toggleDd(dd);
      return;
    }
    if (e.target.closest('[data-bb-lang-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('.bb-dd__panel') || e.target.closest('.bb-lang-foot')) onPick(e);
    if (!e.target.closest('.bb-dd')) closeDd();
  });

  // First visit: after load + 1.5 s, so it never competes with the LCP image. Never opens by itself for crawlers /
  // link previews (they keep no storage, so they would get it on every page): their render shows the page as is.
  // There is no redirect by browser language anywhere: the language changes only on a click.
  var bot = /bot|crawl|spider|slurp|facebookexternalhit|meta-externalagent|whatsapp|bingpreview|google-inspectiontool|mediapartners|adsbot|lighthouse-ci/i.test(navigator.userAgent || '');
  if (force) {
    // Test switch: always opens (the saved choice is kept; nothing else changes).
    var now = function () {
      setTimeout(open, 600);
    };
    if (document.readyState === 'complete') now();
    else window.addEventListener('load', now);
  } else if (tpl && !saved() && !bot) {
    var start = function () {
      setTimeout(function () {
        if (!saved()) open();
      }, 1500);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }
})();
